import React, { useState } from "react";
import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";
import { motion } from "framer-motion";
import { toast } from "react-toastify";

const BulkUpdate = () => {
  const [selectedFile, setSelectedFile] = useState<any>(null);
  const [action, setAction] = useState(false);
  const [open, setOpen] = useState(false);

  const handleFileChange = (event: any) => {
    const file = event.target.files?.[0] || null;
    setSelectedFile(file);
  };

  const handleUploadFile = () => {
    toast.dismiss();
    if (!selectedFile) {
      toast.error("Please select a file first.");
    } else {
      setOpen(true);
    }
  };

  const uploadFile = async () => {
    toast.dismiss();
    setAction(true);
    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await axiosInterceptorInstance.post(
        "/dashboard/BulkInsert",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      toast.info(response.data.message);
    } catch (error) {
      console.error("Upload failed:", error);
      toast.error("File upload failed.");
    } finally {
      setAction(false);
      setOpen(false);
      setSelectedFile(null);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Bulk Update Form</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                style={{ width: "300px" }}
                variant="contained"
                component="label"
              >
                Choose File
                <input
                  key={selectedFile ? selectedFile.name : "file-input"}
                  type="file"
                  hidden
                  onChange={handleFileChange}
                  accept=".csv"
                />
              </Button>
              {selectedFile && (
                <p>
                  <strong>File Name:</strong> {selectedFile.name}
                </p>
              )}
            </Grid>
            <Grid item xs={4}>
              <Button
                onClick={handleUploadFile}
                className="dButton dButton2"
                variant="contained"
              >
                Upload File
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Bulk Update Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Would you really like to upload this file?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            className="dButton dButton2 dbuttonSec"
            onClick={() => setOpen(false)}
          >
            No
          </Button>
          <Button
            variant="contained"
            className="dButton dButton2"
            onClick={uploadFile}
            disabled={action}
            autoFocus
          >
            {action ? <CircularProgress color="inherit" size={24} /> : "Yes"}
          </Button>
        </DialogActions>
      </Dialog>
    </motion.div>
  );
};

export default BulkUpdate;
